(() => {
  document.querySelectorAll('[data-pk-test]').forEach(root => {
    if(root.dataset.photoBridgeInitialized)return;
    root.dataset.photoBridgeInitialized='true';
    const origin='https://cutecircuit.com';
    let preview=null,design=null;
    const dialog=root.querySelector('[data-photo-dialog]');
    const copy=JSON.parse(dialog?.querySelector('[data-photo-copy]')?.textContent||'{}');
    window.addEventListener('message',event=>{
      if(event.origin!==origin||event.source!==preview||!preview)return;
      if(event.data?.type==='cc:parka-ready'&&design){
        preview.postMessage({type:'cc:parka-design',design},origin);
      }
      if(event.data?.type==='cc:parka-return')window.focus();
    });
    root.querySelectorAll('[data-photo-try]').forEach(button=>button.addEventListener('click',()=>{
      try{
        design=button.dataset.photoTry==='original'?root.pkOriginalDesign?.():button.dataset.photoTry==='saved'?root.pkSavedDesign:root.pkPhotoDesign?.();
      }catch{design=null;}
      if(!design){window.alert(copy.design_loading||copy.error);return;}
      preview=window.open('about:blank','cc-parka-photo-preview');
      if(!preview){window.alert('Please allow a new tab to open your Parka try-on.');return;}
      preview.location.href=origin+'/tryon/';
      preview.focus();
    }));
  });
})();
